import React from 'react';
import './ComingSoon.css';

const Recordings = () => {
  return (
    <div className="coming-soon-page">
      <div className="coming-soon-container">
        <div className="coming-soon-icon">📋</div>
        <h1>Atendimentos</h1>
        <p>Esta funcionalidade estará disponível em breve.</p>
        
        <div className="features-preview">
          <h3>Funcionalidades planejadas:</h3>
          <ul>
            <li>Histórico completo de atendimentos</li>
            <li>Filtros por período e vendedor</li>
            <li>Reprodução de gravações</li>
            <li>Análise de qualidade</li>
            <li>Exportação de relatórios</li>
            <li>Busca por palavras-chave</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Recordings;